<template>
  <div>
    <input
      class="form-control"
      type="text"
      :disabled="disabled"
      v-model="telephone"
      @input="evOnInput($event.target.value)"
      @change="evOnChange($event.target.value)"
      maxlength="16"
    />
  </div>
</template>

<script>
export default {
  name: "BInputPhone",

  props: {
    value: { type: String, default: "" },
    disabled: { type: Boolean, default: false },
  },

  data() {
    return {
      telephone: "",
    };
  },

  created() {
    if (!this.value) return;
    this.telephone = this.value;
    this.retrieve();
  },

  watch: {
    value() {
      if (!this.value) return;
      this.telephone = this.value;
      this.retrieve();
    },
  },

  methods: {
    async evOnInput(value) {
      this.$emit("input", value);
    },

    async evOnChange(value) {
      this.$emit("change", value);
      this.retrieve();
    },

    retrieve() {
      if (this.telephone.length === 0) {
        return;
      }

      let filter = this.telephone.replace(/[^0-9]/g, "");

      if (filter.length <= 10) {
        this.telephone = filter.replace(
          /^([0-9]{2})([0-9]{4})([0-9]{4})$/,
          "($1) $2-$3"
        );
      } else if (filter.length == 11) {
        this.telephone = filter.replace(
          /^([0-9]{2})([0-9]{1})([0-9]{4})([0-9]{4})$/,
          "($1) $2.$3-$4"
        );
      } else {
        this.telephone = filter.replace(/^([0-9]{2})([0-9]*)$/, "($1) $2");
      }
    },
  },
};
</script>

<style>
</style>
